import RedirectButton from 'components/atoms/redirect-button'
import { SHIPPING_METHOD } from 'domains/consignment-inbound-request/constants/consignment-inbound-request-constants'
import ShippingMethodBadge from 'domains/consignment-inbound-request/shipping-method-badge'
import ConsignmentInboundRequestStatusBadge from 'domains/consignment-inbound-request/status-badge/consignment-inbound-request-status-badge'
import PropTypes from 'prop-types'
import { Card, CardHeader, Table, UncontrolledCollapse } from 'reactstrap'
import TimeUtil from 'utils/time-util'


const proptypes     = {
  inboundRequest   : PropTypes.object,
  showDetailButton : PropTypes.bool
}
const ACCEPTED_KEYS = [
  'date',
  'admin name',
  'note'
]
const Notes         = ( { notes, keys } ) => {
  const arrayMessage = notes && Object.entries(notes) || []

  return arrayMessage.map(([ key, value ], index) => {
    if (keys && keys.includes(key)){
      return (
        <div key={ `note-message-${index}` } className='mb-3'>
          <div className='font-weight-bold small text-muted'>{ key }</div>
          <div>{ value }</div>
        </div>
      )
    }
    else if (!keys){
      return (
        <div key={ `note-message-${index}` } className='mb-3'>
          <div className='font-weight-bold small text-muted'>{ key }</div>
          <div>{ value }</div>
        </div>
      )
    }
  })
}
/**
 * Map to disabled props in Button edit
 * @param {object} inbound Seller Inbound
 */
// const isAbleToEdit = (inbound) => {
//   let isDisalbed = false

//   const receivedStatusMap = {
//     [STATUS.PENDING]   : false,
//     [STATUS.CANCELLED] : true
//   }

//   isDisalbed = receivedStatusMap[inbound.received_status]

//   return isDisalbed
// }

/**
 * Show card information about Consignment Inbound Request
 * @param {object} inboundRequest Consignment Inbound Request
 */
const ConsignmentInboundRequestCard = ({ inboundRequest, showDetailButton=false }) => (
  <Card>

    <CardHeader>
      <div>
        <span className='small text-uppercase text-light font-weight-bolder'>
          { 'Consignment Inbound Request' }
        </span>
        <h2>
          <span className='mr-3'>{ inboundRequest?.code }</span>
          <small>
            <ShippingMethodBadge shippingMethod={ inboundRequest?.shipping_method }/>
          </small>
        </h2>
      </div>
      {
        showDetailButton && (
          <RedirectButton
            size={ 'sm' }
            text={ 'Lihat Detail' }
            path={ `/app/consignment/inbound-requests/${inboundRequest?.id}/detail` }
            color={ 'primary' }
            outline
          />
        )
      }
      { /* Disable until edit endpoint exist */ }
      { /* <RedirectButton
        size={ 'sm' }
        text={ 'Edit' }
        path={ `/app/sellers/inbounds/edit/${inboundRequest.id}` }
        color={ 'success' }
        disabled={ isAbleToEdit(inboundRequest) }
      /> */ }
    </CardHeader>

    <Table hover className='mb-0'>
      <tbody>
        <tr>
          <th scope='row'>ID</th>
          <td>{ inboundRequest?.id }</td>
        </tr>
        <tr>
          <th scope='row'>Status</th>
          <td><ConsignmentInboundRequestStatusBadge status={ inboundRequest?.status } /></td>
        </tr>
        <tr>
          <th scope='row'>Quantity</th>
          <td>{ inboundRequest?.quantity }</td>
        </tr>
        <tr>
          <th scope='row'>Schedule Date</th>
          <td>{ TimeUtil.format(inboundRequest?.scheduled_at) }</td>
        </tr>
        <tr>
          <th scope='row'>Received Quantity</th>
          <td>{ inboundRequest?.received_quantity }</td>
        </tr>
        <tr>
          <th scope='row'>Notes</th>
          <td style={{ whiteSpace: 'break-spaces' }}>
            <Notes notes={ inboundRequest?.notes } keys={ ACCEPTED_KEYS } />
          </td>
        </tr>
      </tbody>
    </Table>

    {
      inboundRequest?.shipping_method==SHIPPING_METHOD.PICKUP
        ? (
          <div className='accordion'>
            <CardHeader role="tab" id={ `consignment-inbound-request-${inboundRequest?.id}-pickup` }>
              <h5 className="mb-0">Pickup Details</h5>
            </CardHeader>
            <UncontrolledCollapse toggler={ `consignment-inbound-request-${inboundRequest?.id}-pickup` }>
              <Table responsive className='mb-0'>
                <tr>
                  <th scope='row'>Kendaraan</th>
                  <td className='text-wrap'>{ inboundRequest?.pickup_vehicle_type }</td>
                </tr>
                <tr>
                  <th scope='row'>Kurir</th>
                  <td className='text-wrap'>{ inboundRequest?.pickup_courier }</td>
                </tr>
                <tr>
                  <th scope='row'>Tracking Number</th>
                  <td className='text-wrap'>{ inboundRequest?.pickup_tracking_number }</td>
                </tr>
                <tr>
                  <th scope='row'>Street Address</th>
                  <td className='text-wrap'>{ inboundRequest?.pickup_address?.street_address }</td>
                </tr>
                <tr>
                  <th scope='row'>Kecamatan</th>
                  <td>{ inboundRequest?.pickup_address?.district }</td>
                </tr>
                <tr>
                  <th scope='row'>Kelurahan</th>
                  <td>{ inboundRequest?.pickup_address?.sub_district }</td>
                </tr>
                <tr>
                  <th scope='row'>Kota</th>
                  <td>{ inboundRequest?.pickup_address?.city }</td>
                </tr>
                <tr>
                  <th scope='row'>Provinsi</th>
                  <td>{ inboundRequest?.pickup_address?.province }</td>
                </tr>
                <tr>
                  <th scope='row'>Kode Pos</th>
                  <td>{ inboundRequest?.pickup_address?.postal_code }</td>
                </tr>
              </Table>
            </UncontrolledCollapse>
          </div>
        )
        : null
    }

  </Card>
)

ConsignmentInboundRequestCard.propTypes = proptypes

export default ConsignmentInboundRequestCard